<template>
  <div>
    <el-dialog
      :visible.sync="showDialog"
      custom-class="dialog-clear-style"
      :show-close="false"
      top="0"
      append-to-body
      width="816px"
    >
      <div
        class="dynamic-detail-wrap"
        :class="!moveComment && 'hover-visible'"
        @click="showDialog = false"
      >
        <div class="dynamic-detail" @click.stop>
          <div v-if="isLoading" class="loading-wrap">
            <i class="el-icon-loading"></i>
          </div>
          <template v-else-if="info.userUuid">
            <div class="dynamic-detail-title">
              <fps-avatar
                class="user-avatar"
                :src="info.avatarUrl"
                :dressup="info.avatarFrame"
                :level="info.userLevel"
                :style="{ transform: `scale(${info.userLevel > 5 ? 0.8 : 1})` }"
                @click.native="openDetail(info)"
              />
              <div class="text-wrap">
                <div class="nickname">
                  <span>{{ info.nickname }}</span>
                  <fps-icon
                    v-if="info.userUuid == adminUuid"
                    type="v-mark"
                    class="is-admin"
                    size="18"
                    color="#FFA24E"
                  />
                  <div
                    v-else
                    class="userlevel-tag level-mg"
                    :class="`level-${info.userLevel}`"
                  ></div>
                </div>
                <span class="create-time">{{
                  timeToMin(info.createTime)
                }}</span>
              </div>
              <template
                v-if="!userInfo || (info && info.userUuid !== userInfo.uuid)"
              >
                <fps-icon
                  v-if="isReace"
                  type="followed pointer"
                  size="28"
                  @click.native="handleReace"
                />
                <button v-else class="reace-btn pointer" @click="handleReace">
                  追蹤
                </button>
              </template>
              <FeedTool
                v-if="info.userUuid !== adminUuid"
                class="feed-tool"
                :operateUuid="info.userUuid"
                :masterUuid="info.userUuid"
                @clickdelete="deleteDynamic"
              />
            </div>
            <div v-if="info.content.videoContent" class="video-wrap">
              <FpsVideo
                :longWidth="longWidth"
                :src="info.content.videoContent.videoUrl"
                :position="longWidth ? 'cover' : 'contain'"
              />
            </div>
            <div v-else-if="info.content.imageContent" class="image-wrap">
              <div class="custom-swiper custom-swiper-banner">
                <el-carousel
                  ref="banner"
                  class="banner-logined"
                  height="423px"
                  :autoplay="false"
                  trigger="click"
                  arrow="never"
                  :loop="true"
                  :indicator-position="
                    info.content.imageContent.imageUrlList.length > 1
                      ? ''
                      : 'none'
                  "
                >
                  <el-carousel-item
                    v-for="(item, i) in info.content.imageContent.imageUrlList"
                    :key="'image' + i"
                  >
                    <fps-scale-img
                      :src="item"
                      :imageList="info.content.imageContent.imageUrlList"
                      :defaultIndex="i"
                      borderRadius="4px"
                      color="#000"
                      size="contain"
                    />
                  </el-carousel-item>
                </el-carousel>
                <div
                  v-show="info.content.imageContent.imageUrlList.length > 1"
                  class="custom-arrow custom-arrow-left"
                  @click="swipeChange('prev', 'banner')"
                >
                  <fps-icon type="arrow-left" size="16" color="#fff" />
                </div>
                <div
                  v-show="info.content.imageContent.imageUrlList.length > 1"
                  class="custom-arrow custom-arrow-right"
                  @click="swipeChange('next', 'banner')"
                >
                  <fps-icon type="arrow-right" size="16" color="#fff" />
                </div>
              </div>
            </div>
            <div v-if="dynamicText" class="content-wrap">
              <div v-html="dynamicText" class="text-content" />
            </div>
            <div v-if="info.content.skillContent" class="skill-wrap">
              <button @click.stop="openSkillDetail">
                <!-- <img class="game-logo" :src="info.content.skillContent.skill.gameLogo" > -->
                <span class="skill-name">{{
                  info.content.skillContent.skill.gameName
                }}</span>
                <span class="skill-price"
                  >{{ info.content.skillContent.skill.salesPrice }}幣/{{
                    info.content.skillContent.skill.salesUnit
                      | salesUnitTranslate
                  }}</span
                >
              </button>
            </div>
            <div class="dynamic-feel">
              <div class="white-commnet pointer" @click="toWriteComment">
                <fps-icon class="edit-icon" type="edit2" size="18" />
                <span v-if="info.commentCount">馬上留言，加入討論吧</span>
                <span v-else>馬上留言，搶第一樓～</span>
              </div>
              <div class="feed-buttons">
                <el-popover
                  v-if="!userInfo || userInfo.uuid !== info.useruuid"
                  v-model="showSendGift"
                  placement="top-end"
                  title="禮物"
                  width="399"
                  trigger="click"
                  class="send-gifts one-btn"
                  popper-class="send-gifts-popover"
                >
                  <fps-icon
                    class="close-popover"
                    type="close"
                    @click.native="showSendGift = false"
                  />
                  <SendGift
                    ref="send_gift"
                    startPadding="2.5px 7.5px"
                    :playerUserUuid="info.userUuid"
                    :success="sendGiftSuccess"
                  />
                  <button
                    slot="reference"
                    class="send-gift-btn"
                    @click="openGiftList"
                  >
                    <fps-icon class="gift-square" type="gift1" size="18" />
                    <span>送禮</span>
                  </button>
                </el-popover>
                <div class="like-container">
                  <Like
                    v-model="info.isLike"
                    :momentId="momentId"
                    class="like-wrap"
                    size="18"
                    @change="likeChange"
                  />
                  <span>喜歡</span>
                </div>
              </div>
            </div>
            <div v-if="showWriteComment" class="write-comment-wrap">
              <div class="write-comment" @click="commentWriteFocus">
                <textarea
                  v-model="commnetText"
                  ref="comment_write"
                  class="comment-area"
                  :maxlength="maxlength"
                  rows="3"
                  @click.stop
                />
                <span class="write-count"
                  >{{ commnetText.length }}/{{ maxlength }}</span
                >
              </div>
              <div class="comment-btns">
                <button
                  class="cancel-comment"
                  @click="showWriteComment = false"
                >
                  取消
                </button>
                <button class="confirm-comment" @click="submitComment">
                  <i v-if="submitingComment" class="el-icon-loading"></i>
                  <span v-else>提交</span>
                </button>
              </div>
            </div>
            <template v-if="info.commentCount || info.likeCount">
              <div class="line" />
              <div class="count-wrap">
                <div v-if="info.likeCount" class="like-count">
                  {{ info.likeCount }}次喜歡
                </div>
                <div v-if="info.commentCount" class="moment-count">
                  共{{ info.commentCount }}條留言
                </div>
              </div>
            </template>
            <div
              v-if="info.commentList && info.commentList.length"
              class="comment-list"
            >
              <CommmentItem
                v-for="(c, i) in info.commentList"
                :key="'comment-' + c.id"
                :comment="c"
                :masterUuid="info.userUuid"
                :showReply="true"
                @replycomment="replyComment($event, i)"
                @deletereply="deleteReply(i, $event)"
                @updatereply="updateReply($event, i)"
                @deletecomment="deleteComment(i)"
                @mouseenter.native="moveComment = true"
                @mouseleave.native="moveComment = false"
              />
            </div>
          </template>
        </div>
      </div>
    </el-dialog>
    <SkillDetail
      v-if="info.content && info.content.skillContent"
      v-model="showSkillDetail"
      :info="skillInfo"
    />
  </div>
</template>
<script>
import { getFollowInfo, followUser } from '@/api';
import { getMomentInfo, writeMomentComment, deleteDynamic } from './moment';
import { mapGetters } from 'vuex';

import Like from './Like';
import CommmentItem from './comment-item';
import SkillDetail from '@/components/SkillDetail';
import FpsVideo from '@/components/FpsVideo';
import FeedTool from './feed-tool';
import SendGift from '@/components/SendGifts';

export default {
  components: {
    Like,
    CommmentItem,
    SkillDetail,
    FpsVideo,
    FeedTool,
    SendGift
  },
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    momentId: {
      type: Number,
      require: true
    },
    isSquare: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      moveComment: false,
      showDialog: false,
      isReace: false,
      showSendGift: false,
      info: {},
      isLoading: false,
      showWriteComment: false,
      commnetText: '',
      maxlength: 140,
      submitingComment: false,
      showSkillDetail: false,
      skillInfo: {}
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'viewMasterInfo', 'adminUuid']),
    longWidth() {
      if (!this.info.content.videoContent) return false;
      return (
        +this.info.content.videoContent.width >=
        +this.info.content.videoContent.height
      );
    },
    dynamicText() {
      let text = '';
      let tag = '';
      if (this.info.content.textContent)
        text =
          this.info.content.textContent.text.replace(/\n/g, '<br>') + '&nbsp;';
      if (this.info.tag)
        tag = `<span style="color: #FE7538;font-weight: normal;">#${this.info.tag}</span>`;
      return text + tag;
    }
  },
  watch: {
    show(show) {
      this.showDialog = show;
      this.$nextTick(() => {
        this.lockScroll();
      });
    },
    showDialog(show) {
      !show && this.$emit('change', show);
    },
    userInfo(info) {
      if (info) {
        this.getFollowInfo();
      }
    },
    momentId() {
      this.getDefaultData();
    },
    info() {
      this.getFollowInfo();
    }
  },
  created() {
    this.showDialog = this.show;
    this.getDefaultData();
  },
  mounted() {
    this.lockScroll();
  },
  methods: {
    openDetail(info) {
      this.$util.openWindow(`/player-detail/${info.userUuid}`);
    },
    openGiftList() {
      this.$adjust('web_moment_list_gift', {
        moment_uuid: this.info.userUuid,
        id: this.info.id
      });
    },
    deleteDynamic() {
      if (this.deleting) return;
      this.deleting = true;
      deleteDynamic({
        momentId: this.info.id
      })
        .then(() => {
          this.$emit('deletedynamic');
          this.deleting = false;
        })
        .catch(() => {
          this.deleting = false;
        });
    },
    deleteComment(i) {
      this.info.commentList.splice(i, 1);
    },
    updateReply(list, i) {
      this.info.commentList[i].replyList = list;
      this.$set(this.info, 'commentList', this.info.commentList);
    },
    deleteReply(i, { index }) {
      const comment = this.info.commentList[i];
      comment.replyCount--;
      comment.replyList.splice(index, 1);
      this.$set(this.info, 'commentList', this.info.commentList);
    },
    sendGiftSuccess(giftObj) {
      this.showSendGift = false;
      this.$util.openChatWindow(this.userInfo.uuid, this.info.userUuid, '', {
        giftId: giftObj.giftId,
        basePath: giftObj.giftAnimationUrl
      });
    },
    openSkillDetail() {
      this.showSkillDetail = true;
      this.skillInfo = {
        ...this.info.content.skillContent,
        userUuid: this.info.userUuid
      };
      this.isSquare &&
        this.$adjust('web_moment_list_skill', {
          moment_uuid: this.info.userUuid,
          skill_id: this.info.content.skillContent.skill.id
        });
    },
    replyComment(data, i) {
      const comment = this.info.commentList[i];
      comment.replyCount = +comment.replyCount + 1;
      if (!comment.replyList) comment.replyList = [];
      comment.replyList.push(data);
      this.info.commentList.splice(i, 1, comment);
    },
    submitComment() {
      const { commnetText, momentId } = this;
      if (this.submitingComment || !commnetText) return;
      this.submitingComment = true;
      writeMomentComment({
        content: commnetText,
        momentId
      })
        .then(({ data }) => {
          this.submitingComment = false;
          this.commnetText = '';
          this.showWriteComment = false;
          this.$message.success('提交成功');
          let { commentList } = this.info;
          if (!commentList) commentList = [];
          this.$set(this.info, 'commentCount', +this.info.commentCount + 1);
          commentList.unshift(data);
        })
        .catch(() => {
          this.$message.error('提交失敗');
          this.submitingComment = false;
        });
    },
    toWriteComment() {
      if (!this.userInfo) {
        this.$util.Login().then(() => {
          this.toWriteComment();
        });
        return;
      }
      this.showWriteComment = true;
      this.$nextTick(() => {
        this.commentWriteFocus();
      });
      this.isSquare &&
        this.$adjust('web_moment_list_like', {
          moment_uuid: this.info.userUuid
        });
    },
    commentWriteFocus() {
      const dom = this.$refs.comment_write;
      if (dom) dom.focus();
    },
    timeToMin(time) {
      const d = new Date(time);
      const now = Date.now();
      const createTime = d.getTime();
      // 距离现在几分钟
      let sub = Math.floor((now - createTime) / 60 / 1000);
      if (sub < 5) return '剛剛發佈';
      if (sub < 60) return sub + '分鐘前';
      if (sub < 60 * 24) return Math.floor(sub / 60) + '小時前';
      if (sub < 7 * 60 * 24) return Math.floor(sub / 60 / 24) + '天前';
      let month = d.getMonth() + 1;
      if (month < 10) {
        month = '0' + month;
      }
      let date = d.getDate();
      if (date < 10) {
        date = '0' + date;
      }
      return `${d.getFullYear()}-${month}-${date}`;
    },
    lockScroll() {
      if (this.showDialog) {
        window.document.body.style.overflow = 'hidden';
      } else {
        window.document.body.style.overflow = 'auto';
      }
    },
    likeChange(like) {
      if (like) {
        this.$set(this.info, 'likeCount', this.info.likeCount + 1);
        this.isSquare &&
          this.$adjust('web_moment_list_like', {
            moment_uuid: this.info.userUuid
          });
      } else {
        this.$set(this.info, 'likeCount', this.info.likeCount - 1);
      }
    },
    // 切换轮播
    swipeChange(method, refName) {
      const $swipe = this.$refs[refName];
      if (!$swipe) return;
      $swipe[method]();
    },
    setDefaultData() {
      this.isReace = false;
      this.info = {};
      this.isLoading = false;
      this.showWriteComment = false;
      this.commnetText = '';
      this.submitingComment = false;
      this.skillInfo = {};
    },
    getDefaultData() {
      if (!this.momentId) return;
      this.setDefaultData();
      this.isLoading = true;
      this.getDetailInfo().then(() => {
        this.isLoading = false;
      });
    },
    getDetailInfo() {
      return getMomentInfo({
        momentId: this.momentId
      }).then(({ data }) => {
        this.info = data;
      });
    },
    getFollowInfo() {
      if (
        !this.info ||
        !this.info.userUuid ||
        !this.userInfo ||
        this.info.userUuid === this.userInfo.uuid
      )
        return;
      getFollowInfo({
        uuid: this.info.userUuid
      }).then(({ data }) => {
        if (data.followStatus === 'Unfollow') {
          this.isReace = false;
        } else if (data.followStatus === 'Follow') {
          this.isReace = true;
        }
      });
    },
    handleReace() {
      if (!this.userInfo) {
        this.$util.Login().then(() => {
          if (!this.isSelf) {
            this.handleReace();
          }
        });
        return;
      }
      if (this.messageStartObj) return;
      if (this.messageEndObj) {
        this.messageEndObj.close();
        this.messageEndObj = null;
      }
      this.messageStartObj = this.$message(
        this.isReace ? '取消追蹤中...' : '追蹤中...'
      );
      let messageText = this.isReace ? '取消追蹤' : '追蹤';
      followUser({
        followOptType: this.isReace ? 'Unfollow' : 'Follow',
        uuid: this.info.userUuid
      })
        .then(() => {
          this.isReace = !this.isReace;
          if (this.isReace) {
            this.$store.dispatch('app/updateSomeOfViewMasterInfo', {
              follower: +this.viewMasterInfo.follower + 1
            });
          } else {
            this.$store.dispatch('app/updateSomeOfViewMasterInfo', {
              follower: +this.viewMasterInfo.follower - 1
            });
          }
          this.messageStartObj.close();
          this.messageStartObj = null;
          this.messageEndObj = this.$message({
            message: messageText + '成功',
            type: 'success'
          });
        })
        .catch(e => {
          console.error(e.msg);
          this.messageStartObj.close();
          this.messageEndObj = this.$message.error(messageText + '失敗');
          this.messageStartObj = null;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.like-wrap {
  position: relative;
  &::after {
    content: '';
    position: absolute;
    left: -13px;
    top: -5px;
    width: 74px;
    height: 28px;
  }
}
.dynamic-detail-wrap {
  height: 100vh;
  @include flex;
  .feed-tool {
    transform: scale(0);
    margin-left: 24px;
  }
  &.hover-visible .feed-tool {
    transform: scale(1);
  }
}
.dynamic-detail {
  background: #ffffff;
  border: 1px solid #efefef;
  box-sizing: border-box;
  border-radius: 4px;
  width: 816px;
  max-height: calc(100vh - 44px);
  padding: 24px 32px;
  overflow-y: auto;
  @include hideScrollBar(0, 0);
  .loading-wrap {
    width: 100%;
    @include flex;
    padding: 40px;
    font-size: 24px;
  }
  .dynamic-detail-title {
    margin-bottom: 10px;
    @include flex;
    .user-avatar {
      width: 38px;
      height: 38px;
      margin-right: 10px;
      cursor: pointer;
    }
    .text-wrap {
      flex: 1;
      @include flex(center, flex-start, column);
      .nickname {
        @include flex(flex-start);
        overflow: hidden;
        font-weight: 500;
        font-size: 14px;
        height: 20px;
        color: $color-gray-1;
        margin-bottom: 2px;
        span {
          font-weight: 500;
          font-size: 14px;
          color: $color-gray-1;
        }
        .is-admin {
          margin-left: 3px;
        }
        .userlevel-tag {
          margin-left: 4px;
        }
      }
      .create-time {
        font-size: 12px;
        line-height: 16px;
        color: $color-gray-3;
      }
    }
    .reace-btn {
      width: 54px;
      height: 26px;
      line-height: 26px;
      border-radius: 15px;
      border: 1px solid $color-gray-2;
      @include flex;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.3px;
      color: $color-gray-1;
    }
  }
  .video-wrap,
  .image-wrap {
    margin-bottom: 15px;
  }
  .video-wrap {
    width: 752px;
    height: 453px;
  }
  .content-wrap {
    margin-bottom: 16px;
    @include flex(flex-start);
    .text-content {
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      margin-right: 4px;
      color: $color-gray-1;
      .tag-content {
        color: #fe7538;
      }
    }
  }
  .skill-wrap {
    margin-bottom: 21px;
    button {
      .game-logo {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        margin-right: 8px;
      }
      padding: 4px 16px;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: $color-gray-1;
      @include flex;
      background: $color-yellow;
      border-radius: 40px;
      .skill-name {
        margin-right: 16px;
      }
    }
  }
  .dynamic-feel {
    @include flex(space-between);
    margin-bottom: 21px;
    .white-commnet {
      @include flex;
      span {
        font-size: 14px;
        line-height: 18px;
        letter-spacing: -0.00032px;
        color: $color-gray-3;
        margin-left: 4px;
      }
    }
    .feed-buttons {
      @include flex;
    }
    .like-container {
      @include flex;
      span {
        font-size: 14px;
        line-height: 18px;
        letter-spacing: -0.00032px;
        color: $color-gray-3;
        margin-left: 4px;
      }
    }
    .send-gift-btn {
      @include flex;
      margin-right: 28px;
      width: 74px;
      height: 28px;
      color: $color-gray-2;
      span {
        font-size: 14px;
        line-height: 18px;
        letter-spacing: -0.00032px;
        color: $color-gray-3;
        margin-left: 4px;
      }
    }
  }
  .write-comment-wrap {
    margin-bottom: 16px;
    .comment-btns {
      margin-top: 8px;
      @include flex(flex-end);
      button {
        width: 80px;
        height: 32px;
        @include flex;
        font-size: 13px;
        line-height: 18px;
        border-radius: 50px;
      }
      .cancel-comment {
        color: $color-gray-2;
        border: 1px solid $color-split;
        margin-right: 10px;
      }
      .confirm-comment {
        color: $color-gray-1;
        background: $color-yellow;
      }
    }
  }
  .write-comment {
    background: #f9f9f9;
    border: 1px solid $color-split;
    border-radius: 8px;
    padding: 12px 12px 10px;
    @include flex(flex-start, flex-end, column);
    .comment-area {
      width: 100%;
      font-size: 14px;
      line-height: 20px;
      color: $color-gray-1;
      resize: none;
    }
    .write-count {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: $color-gray-4;
    }
  }
  .line {
    width: 100%;
    height: 1px;
    background: $color-split;
    margin-bottom: 16px;
  }
  .count-wrap {
    @include flex(flex-start);
    font-weight: 500;
    font-size: 12px;
    line-height: 17px;
    color: $color-gray-3;
    .like-count {
      color: $color-gray-1;
      margin-right: 35px;
    }
  }
}
.custom-swiper {
  width: 100%;
  margin-top: 8px;
  position: relative;
  .one-game {
    & > div {
      width: 100%;
      height: 100%;
      &.no-empty:hover,
      &.selected-photo {
        position: relative;
        &::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          border: 1px solid $color-price;
          box-shadow: 0px 0px 8px rgba(216, 121, 1, 0.8);
          border-radius: 4px;
        }
      }
    }
    .game-image,
    .empty-img {
      border-radius: 4px;
      width: 100%;
      height: 100%;
      background: rgba($color: $color-button, $alpha: 0.7);
    }
  }
  .custom-arrow {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.4) !important;
    opacity: 0;
  }
  &:hover .custom-arrow {
    opacity: 1;
  }
  .custom-arrow-right {
    right: 4px;
  }
  .custom-arrow-left {
    left: 4px;
  }
}
</style>
